// Links between views that open a specific item, for the admin and cashier layouts. Each target
// view reads its query once it has loaded and then drops it (see openFromLink):
//   activity list: ?activity=<id>[&tab=participants]
//   persons page:  ?person=<id>
// Other layouts have no such views, so there is no link (null).

export const currentLayout = (pathname = window.location.pathname) => pathname.split('/')[1] || ''

export const activityListPath = (layout = currentLayout()) => {
  if (layout === 'admin') return '/admin/activities/list'
  if (layout === 'cashier') return '/cashier/activities'
  return null
}

export const personPath = (personId, layout = currentLayout()) => {
  if (!personId) return null
  if (layout !== 'admin' && layout !== 'cashier') return null
  return '/' + layout + '/customers/persons?person=' + encodeURIComponent(personId)
}
